import { useMemo } from "react";
import { useSelector } from "react-redux";

function useIsLoggedIn() {
  const loggedIn = useSelector((state) => state.auth.loggedIn);

  return useMemo(() => {
    return loggedIn;
  }, [loggedIn]);
}

export { useIsLoggedIn as default };
